import { FC, useRef, useState} from "react"
import { AgGridColumn, AgGridReact } from "ag-grid-react"
import '../../../../ag-grid.css'
import '../../../../ag-theme-alpine.css'
import { warning } from "../../../../utils/notifications"
import { defaultRenderer } from "../../../../utils/helperFunctions"
import { EditEntregasModalDialog } from "../../Entregas/EntregasTable/EditEntregasModalDialog/EditEntregasModalDialog"



export const TrucksTable:FC<any> = (props) => {

    const gridRef :any= useRef();

    const { data, setData, dataMASTER, saveLoading,  changesFlag, setChangesFlag, id,  tabID } = props

    const [ visible, setVisible ] = useState<boolean>(false)

    const [ selectedCell, setSelectedCell ] = useState<any>()

    const [ selectedRow, setSelectedRow ] = useState<any>()

    const [ mode, setMode] = useState<string>("")

    const [ type, setType ] = useState<string>("PKM")

    const handleClose = () => {
        setSelectedCell(undefined)
        setSelectedRow(undefined)
        
        setVisible(false)
        
        setMode("")
        
    }

   

    const handleCellStyleP = (params:any) => {
        let original = dataMASTER?.find((ori:any) => ori.id_proveedor === params.data.id_proveedor)?.[params.column.colId]
        
        if(original != params.value) {
            return {backgroundColor: 'orange', color: 'white', fontWeight:'bold',border:'1px solid #dee2e6'}
        } else {
            return {backgroundColor: 'transparent',color: 'black',fontWeight:'normal',border:'1px solid #dee2e6'}
        } 
    }

    const handleOpenCellModal = (params:any) => {
        let { colId } = params.column
        setSelectedCell(colId)
        setSelectedRow(params.data)
        setVisible(true)
            
    }
    

    return (
        <div className="ag-theme-alpine" style={saveLoading? {display:'flex',flexDirection:'column', height:'95%', width: '95%',opacity:0.6 } : {display:'flex',flexDirection:'column', height:'95%', width: '95%' }}>
            <EditEntregasModalDialog
                visible={visible}
                setVisible={setVisible}
                handleClose={handleClose}
                
                selectedCell={selectedCell}
                setSelectedCell={setSelectedCell}
                selectedRow={selectedRow}
                setSelectedRow={setSelectedRow}
                mode={mode}
                setMode={setMode}
                dataTable={data}
                dataTableMASTER={dataMASTER}
                setData={setData}
                type={type}   
                setType={setType}
                changesFlag={changesFlag}
                setChangesFlag={setChangesFlag}
                id={id}
                tabID={tabID}
                comm={true}
            />
            <AgGridReact
                ref={gridRef}
                headerHeight={30}
                getRowHeight={() => 30}
                onCellDoubleClicked={handleOpenCellModal}
                rowData={data}
                enableCellTextSelection
                >
                <AgGridColumn sortable headerClass={"header-border header-resize"} cellStyle={handleCellStyleP}   suppressNavigable={true}    headerName={"ID Proveedor"} field={"id_proveedor"}></AgGridColumn>

                <AgGridColumn cellStyle={handleCellStyleP} headerClass={"header-border header-resize"} sortable filter={true}  flex={1} suppressNavigable={true} tooltipField={"proveedor"}   headerName={"Proveedor"} field={"proveedor"}></AgGridColumn>
                        
                <AgGridColumn cellStyle={handleCellStyleP} headerClass={"header-resize"}  sortable cellRenderer={defaultRenderer}  flex={0.75} suppressNavigable    headerName="TM (Camión)" field="tm_camion"></AgGridColumn>

            </AgGridReact>
        </div>
            
      
    )
}